import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

import "./style.scss";

export const SemestersButtons = ({ item, semester, setSemester, labels }) => {
    const [jsonData, setJsonData] = useState([]);

    useEffect(() => {
        fetch(`${window.location.href.split("/").slice(0, 3).join("/")}/programs-semesters-labels`)
            .then((response) => response.json())
            .then((json) => setJsonData(json))
            .catch((error) => console.log(error));
    }, [])

    return (
        <div className="semesters-buttons">
            {item.field_semester &&
                Object.keys(item.field_semester).map((cp, i) => (
                    item.field_semester[cp] != null && item.field_semester[cp]?.title &&
                    (cp === "0" || (cp === "1" && labels?.semester_b_available !== null && labels?.semester_b_available !== 0)) ?
                        <Button
                            key={i}
                            aria-label={`${item.field_semester[cp]?.title}, 
                                ${labels.rejection_threshold} ${item.field_semester[cp].field_this_year_rejection_thresh},
                                ${labels.acceptance_threshold} ${item.field_semester[cp].field_this_year_receipt_threshol}`}
                            onClick={(e) =>
                                setSemester({
                                    number: i,
                                    title: item.field_semester[cp]?.title,
                                    field_this_year_receipt_threshol:
                                        item.field_semester[cp]
                                            .field_this_year_receipt_threshol,
                                    field_this_year_rejection_thresh:
                                        item.field_semester[cp]
                                            .field_this_year_rejection_thresh,
                                    field_end_registration:
                                        item.field_semester[cp].field_end_registration,
                                })
                            }
                            variant={semester.number === i ? "dark" : "light"}
                        >
                            <div>{item.field_semester[cp]?.title}</div>
                            {jsonData.data && jsonData.data[item.nid] &&
                                (cp === "0" ? <div>{jsonData.data[item.nid].a}</div> : cp === "1" ?
                                    <div>{jsonData.data[item.nid].b}</div> : null)}
                        </Button> : <></>
                ))}
        </div>
    )

}